var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};

// src/components/partner-session-manager/partner-session-manager.tsx
import React7, { useEffect, useRef as useRef2, useState } from "react";
import { gql as gql7, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";

// src/components/partner-session-manager/__private/__fragments/session-sign-in-dialog/dialog-session.tsx
import React6, { useRef } from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSDialog, EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSParagraph } from "@egds/react-core/text";
import { useDialog } from "@shared-ui/dialog-context";

// src/components/partner-session-manager/common/ui-graphic/ui-graphic.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";

// src/components/partner-session-manager/common/ui-graphic/icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { classNames } from "@egds/react-core/utils";
var IconFragment = gql`
  fragment IconFragments on Icon {
    description
    id
    size
    spotLight
    theme
    title
    withBackground
  }
`;
var SPOTLIGHT_MAP = {
  ["INFO" /* INFO */]: "info",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["STANDARD" /* STANDARD */]: "standard",
  ["WARNING" /* WARNING */]: "warning"
};
var Icon = ({
  className,
  data
}) => {
  var _a, _b;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    className: classNames(className, `booking-servicing-icon-${data.id}`),
    description: data.description,
    id: data.id,
    name: data.id,
    shadow: Boolean(!data.spotLight && data.withBackground),
    size: data.size ? EGDSIconSize[data.size] : void 0,
    spotlight: data.spotLight ? {
      theme: SPOTLIGHT_MAP[data.spotLight],
      background: data.withBackground
    } : void 0,
    title: (_a = data.title) != null ? _a : data.id,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0
  });
};
Icon.displayName = "EGDSIcon";
Icon.fragment = IconFragment;

// src/components/partner-session-manager/common/ui-graphic/illustration.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
var IllustrationFragment = gql2`
  fragment IllustrationFragments on Illustration {
    description
    id
    link: url
  }
`;
var Illustration = ({
  data
}) => /* @__PURE__ */React2.createElement(EGDSIllustrations, {
  alt: data.description,
  url: data.link
});
Illustration.displayName = "Illustration";
Illustration.fragment = IllustrationFragment;

// src/components/partner-session-manager/common/ui-graphic/mark.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSMark, EGDSMarkSize } from "@egds/react-core/mark";
import { classNames as classNames2 } from "@egds/react-core/utils";
var MarkFragment = gql3`
  fragment MarkFragments on Mark {
    description
    id
    markSize: size
    url {
      relativePath
      value
    }
  }
`;
var Mark = ({
  className,
  data
}) => {
  var _a;
  return /* @__PURE__ */React3.createElement(EGDSMark, {
    className: classNames2(className, `booking-servicing-mark-${data.id}`),
    description: data.description,
    id: data.id,
    name: data.id,
    size: data.markSize ? EGDSMarkSize[data.markSize] : void 0,
    url: (_a = data.url) == null ? void 0 : _a.value
  });
};
Mark.displayName = "Mark";
Mark.fragment = MarkFragment;

// src/components/partner-session-manager/common/ui-graphic/ui-graphic.tsx
var __UIGraphicFragment = gql4`
  fragment UIGraphicFragment on UIGraphic {
    ... on Icon {
      ...IconFragments
    }

    ... on Mark {
      ...MarkFragments
    }

    ... on Illustration {
      ...IllustrationFragments
    }
  }

  ${Icon.fragment}
  ${Mark.fragment}
  ${Illustration.fragment}
`;
var UiGraphic = ({
  className,
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React4.createElement(Icon, {
        className,
        data
      });
    case "Mark":
      return /* @__PURE__ */React4.createElement(Mark, {
        className,
        data
      });
    case "Illustration":
      return /* @__PURE__ */React4.createElement(Illustration, {
        data
      });
  }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;

// src/components/partner-session-manager/__private/__fragments/session-sign-in-dialog/dialog-footer.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSPrimaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSDialogFooter } from "@egds/react-core/dialog";
var fragment = gql5`
  fragment EGDSActionDialogFooterFragment on EGDSDialogFooter {
    ... on EGDSStackedDialogFooter {
      buttons {
        ...SessionActionDialogFooterButton
      }
    }
    ... on EGDSInlineDialogFooter {
      buttons {
        ...SessionActionDialogFooterButton
      }
    }
  }

  fragment SessionActionDialogFooterButton on EGDSButton {
    primary
    action {
      ... on UILinkAction {
        target
        useRelativePath
        resource {
          ... on HttpURI {
            value
            relativePath
          }
        }
      }
    }
    accessibility
    ... on UIPrimaryButton {
      accessibility
    }
  }
`;
var getLinkUrl = (linkAction, useRelativePath) => {
  if (linkAction.resource.__typename !== "HttpURI") {
    return void 0;
  }
  return useRelativePath ? linkAction.resource.relativePath : linkAction.resource.value;
};
var buttonComponentMap = {
  UIPrimaryButton: EGDSPrimaryButton,
  UITertiaryButton: EGDSTertiaryButton
};
var getChildrenButtons = (data, onDialogClose) => data.buttons.filter(button => button.__typename in buttonComponentMap).map((button, index) => {
  var _a;
  const Button = buttonComponentMap[button.__typename];
  const commonProps = {
    key: `dialog-footer-button-${index}`,
    analytics: {
      id: `dialog-footer-button-${index}`,
      callback: () => {
        onDialogClose();
      }
    }
  };
  switch ((_a = button.action) == null ? void 0 : _a.__typename) {
    case "UILinkAction":
      {
        const linkAction = button.action;
        const {
          useRelativePath
        } = linkAction;
        const linkUrl = getLinkUrl(linkAction, useRelativePath);
        const linkProps = {
          href: linkUrl,
          target: linkAction.target === "EXTERNAL" /* EXTERNAL */ ? "_blank" : "_self",
          rel: "noopener",
          onClick: onDialogClose
        };
        return linkProps.href ? /* @__PURE__ */React5.createElement(Button, __spreadValues(__spreadValues({}, commonProps), linkProps), button.primary, " ") : null;
      }
    default:
      {
        const linkProps = {
          onClick: onDialogClose
        };
        return /* @__PURE__ */React5.createElement(Button, __spreadValues(__spreadValues({}, commonProps), linkProps), button.primary);
      }
  }
}).filter(button => button !== void 0);
var SessionDialogFooter = ({
  data,
  onDialogClose
}) => {
  const buttons = getChildrenButtons(data, onDialogClose);
  switch (data.__typename) {
    case "EGDSInlineDialogFooter":
      return /* @__PURE__ */React5.createElement(EGDSDialogFooter, {
        stacked: false
      }, buttons);
    default:
      return /* @__PURE__ */React5.createElement(EGDSDialogFooter, {
        stacked: true
      }, buttons);
  }
};
SessionDialogFooter.fragment = fragment;
SessionDialogFooter.displayName = "SessionDialogFooter";

// src/components/partner-session-manager/__private/__fragments/session-sign-in-dialog/dialog-session.tsx
var fragment2 = gql6`
  fragment SessionDialogFragment on Dialog {
    actionDialog {
      ...SessionActionDialogFragment
    }
    actionEndTime
    actionStartTime
    dialogContent
    graphic {
      ...UIGraphicFragment
    }
    title
    triggerMessage {
      label
      accessibility
    }
    __typename
  }

  fragment SessionActionDialogFragment on EGDSActionDialog {
    closeAnalytics {
      referrerId
      linkName
      __typename
    }
    footer {
      ...EGDSActionDialogFooterFragment
    }
  }

  ${SessionDialogFooter.fragment}
  ${UiGraphic.fragment}
`;
var DialogSession = ({
  data,
  dialogId,
  onDialogClose
}) => {
  const [isFinalDialogOpen, finalDialogActions, FinalMemberSignInDialogComponent] = useDialog(dialogId);
  const triggerRef = useRef(null);
  const {
    graphic,
    actionDialog,
    title,
    dialogContent
  } = data;
  const onClose = () => {
    finalDialogActions.closeDialog();
    onDialogClose();
  };
  return /* @__PURE__ */React6.createElement(FinalMemberSignInDialogComponent, null, /* @__PURE__ */React6.createElement(EGDSDialog, {
    dialogShow: isFinalDialogOpen,
    returnFocusOnClose: true,
    triggerRef
  }, /* @__PURE__ */React6.createElement(EGDSDialogContent, null, /* @__PURE__ */React6.createElement(EGDSLayoutFlex, {
    alignItems: "start",
    justifyContent: "start",
    "data-stid": "signin-popup-message-result-"
  }, graphic && /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React6.createElement(EGDSSpacing, {
    margin: {
      inlinestart: "one",
      inlineend: "one"
    }
  }, /* @__PURE__ */React6.createElement(UiGraphic, {
    data: graphic
  }))), /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, {
    minWidth: "full_width"
  }, /* @__PURE__ */React6.createElement(EGDSSpacing, {
    margin: {
      inlinestart: "four",
      inlineend: "one"
    }
  }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(EGDSHeading, {
    align: "left",
    tag: "h2",
    size: 5
  }, title), /* @__PURE__ */React6.createElement(EGDSParagraph, {
    size: 2
  }, dialogContent), (actionDialog == null ? void 0 : actionDialog.footer) && /* @__PURE__ */React6.createElement(SessionDialogFooter, {
    data: actionDialog.footer,
    onDialogClose: onClose
  }))))))));
};
DialogSession.fragment = fragment2;
DialogSession.displayName = "SessionSignInDialog";

// src/components/partner-session-manager/partner-session-manager.tsx
var __Query = gql7`
  query SessionManagerQuery($context: ContextInput!) {
    getSessionConfig(context: $context) {
      status
      eventPerformed
      warning {
        ...SessionDialogFragment
        time
        __typename
      }
      session {
        ...SessionDialogFragment
        time
        __typename
      }
      finalSession {
        ...SessionDialogFragment
        time
        __typename
      }
    }
  }
  ${DialogSession.fragment}
`;
var PartnerSessionManager = ({
  skipSsr
}) => {
  const {
    context
  } = useBexApi();
  const variables = {
    context
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    variables,
    ssr: !skipSsr
  });
  const [showWarning, setWarningDialog] = useState(false);
  const showWarningRef = useRef2(showWarning);
  const [showHardLogout, setHardLogoutDialog] = useState(false);
  const showHardLogoutRef = useRef2(showHardLogout);
  const [showSoftLogout, setSoftLogoutDialog] = useState(false);
  const showSoftLogoutRef = useRef2(showSoftLogout);
  const [, idleLogoutDialog] = useDialog2("idle-session-extension-dialog");
  const [, warningDialog] = useDialog2("warning-session-extension-dialog");
  const [, hardLogoutDialog] = useDialog2("final-session-extension-dialog");
  const createDialog = (dialogId, dialog) => {
    return /* @__PURE__ */React7.createElement(DialogSession, {
      data: dialog,
      dialogId,
      onDialogClose
    });
  };
  const onDialogClose = () => {
    setSoftLogoutDialog(false);
    setWarningDialog(false);
    setHardLogoutDialog(false);
  };
  const convertToMilliseconds = seconds => seconds * 1e3;
  const extendSession = () => {
    var _a, _b;
    if (showHardLogoutRef.current || showSoftLogoutRef.current) {
      return;
    }
    const now = Date.now();
    if ((_a = data == null ? void 0 : data.getSessionConfig.warning) == null ? void 0 : _a.time) {
      localStorage.setItem("warningTime", String(now + convertToMilliseconds(data.getSessionConfig.warning.time)));
    }
    if ((_b = data == null ? void 0 : data.getSessionConfig.session) == null ? void 0 : _b.time) {
      localStorage.setItem("softLogoutTime", String(now + convertToMilliseconds(data.getSessionConfig.session.time)));
    }
  };
  const getHardLogoutTime = () => {
    var _a, _b;
    if ((_b = (_a = data == null ? void 0 : data.getSessionConfig) == null ? void 0 : _a.finalSession) == null ? void 0 : _b.actionEndTime) {
      return new Date(data.getSessionConfig.finalSession.actionEndTime).getTime();
    }
    return Number(localStorage.getItem("hardLogoutTime"));
  };
  const checkForInactivity = () => {
    const now = Date.now();
    const warningTime = Number(localStorage.getItem("warningTime"));
    const softLogoutTime = Number(localStorage.getItem("softLogoutTime"));
    const hardLogoutTime = getHardLogoutTime();
    if (hardLogoutTime && now >= hardLogoutTime) {
      setWarningDialog(false);
      setSoftLogoutDialog(false);
      setHardLogoutDialog(true);
      hardLogoutDialog.openDialog();
      return;
    }
    if (softLogoutTime && now >= softLogoutTime) {
      setWarningDialog(false);
      setSoftLogoutDialog(true);
      setHardLogoutDialog(false);
      idleLogoutDialog.openDialog();
      return;
    }
    if (warningTime && now >= warningTime) {
      setWarningDialog(true);
      setSoftLogoutDialog(false);
      setHardLogoutDialog(false);
      warningDialog.openDialog();
      return;
    }
    setWarningDialog(false);
    setSoftLogoutDialog(false);
    setHardLogoutDialog(false);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      checkForInactivity();
    }, 2e3);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    showWarningRef.current = showWarning;
  }, [showWarning]);
  useEffect(() => {
    showHardLogoutRef.current = showHardLogout;
  }, [showHardLogout]);
  useEffect(() => {
    showSoftLogoutRef.current = showSoftLogout;
  }, [showSoftLogout]);
  useEffect(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if ((_a = data == null ? void 0 : data.getSessionConfig) == null ? void 0 : _a.eventPerformed) {
      for (const event of data.getSessionConfig.eventPerformed) {
        window.addEventListener(event, extendSession);
      }
    }
    const now = Date.now();
    if ((_c = (_b = data == null ? void 0 : data.getSessionConfig) == null ? void 0 : _b.warning) == null ? void 0 : _c.time) {
      localStorage.setItem("warningTime", String(now + convertToMilliseconds(data.getSessionConfig.warning.time)));
    }
    if ((_e = (_d = data == null ? void 0 : data.getSessionConfig) == null ? void 0 : _d.session) == null ? void 0 : _e.time) {
      localStorage.setItem("softLogoutTime", String(now + convertToMilliseconds(data.getSessionConfig.session.time)));
    }
    if ((_g = (_f = data == null ? void 0 : data.getSessionConfig) == null ? void 0 : _f.finalSession) == null ? void 0 : _g.time) {
      localStorage.setItem("hardLogoutTime", String(now + convertToMilliseconds(data.getSessionConfig.finalSession.time)));
    }
    if ((_i = (_h = data == null ? void 0 : data.getSessionConfig) == null ? void 0 : _h.finalSession) == null ? void 0 : _i.actionEndTime) {
      localStorage.setItem("hardLogoutTime", String(new Date(data.getSessionConfig.finalSession.actionEndTime).getTime()));
    }
  }, [data]);
  if (error || loading || !data || data.getSessionConfig.status !== "active") {
    return null;
  }
  return /* @__PURE__ */React7.createElement(React7.Fragment, null, showWarning && data.getSessionConfig.warning && /* @__PURE__ */React7.createElement("div", {
    "data-testid": "warning-session-extension-dialog"
  }, createDialog("warning-session-extension-dialog", data.getSessionConfig.warning)), showSoftLogout && data.getSessionConfig.session && /* @__PURE__ */React7.createElement("div", {
    "data-testid": "idle-session-extension-dialog"
  }, createDialog("idle-session-extension-dialog", data.getSessionConfig.session)), showHardLogout && data.getSessionConfig.finalSession && /* @__PURE__ */React7.createElement("div", {
    "data-testid": "final-session-extension-dialog"
  }, createDialog("final-session-extension-dialog", data.getSessionConfig.finalSession)));
};
PartnerSessionManager.displayName = "sharedui-PartnerSessionManager";
export { PartnerSessionManager };